import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Slider from '@material-ui/core/Slider';
import "../styles/masterStyles.css";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
    },
    margin: {
        height: theme.spacing(3),
    },
}));

const marks = [
    {
        value: 1,
        label: '1 hr',
    },
    {
        value: 2,
        label: '1 d',
    },
    {
        value: 3,
        label: '1 wk',
    },
    {
        value: 4,
        label: '2 wks',
    },
    {
        value: 5,
        label: '1 mon',
    },
];

function valuetext(value) {
    switch(value) {
        case 1: {
            return '1 hr'
        }
        case 2: {
            return '1 d'
        }
        case 3: {
            return '1 wk'
        }
        case 4: {
            return '2 wks'
        }
        case 5: {
            return '1 mon'
        }
    }
}

function labelText (value) {
    return '';
    switch(value) {
        case 1: {
            return 'Repeat'
        }
        case 2: {
            return 'Difficult'
        }
        case 3: {
            return 'Moderate'
        }
        case 4: {
            return 'Easy'
        }
        case 5: {
            return 'Very Easy'
        }
    }
}

const getValue = (value) => {
    switch(value) {
        case 1: {
            return 1;
        }
        case 2: {
            return 24;
        }
        case 3: {
            return 168;
        }
        case 4: {
            return 336;
        }
        case 5: {
            return 720;
        }
        default: {
            return 24;
        }
    }
}

export const ReviewSlider = props => {
    const classes = useStyles();

    const handleChange = name => (event, value) => {
        let time = getValue(value);
        let obj = {
            hourvar: time,
            deckID: (props.deckID ? props.deckID : null),
            mcid: (props.mcid ? props.mcid : null),
            key: (props.myKey ? props.myKey : null),
            questionID: (props.questionID ? props.questionID : null),
        };

        if (!obj.mcid || !obj.key || !obj.deckID || !obj.questionID ) {
            return false;
        } else {
            props.putNextReviewDate(obj);

            return false;
        }

    }

    if (props.gameMode != 3) {
        return null;
    } else {
        return (
            <div className={classes.root}>

                {/* <Typography varient="body1">Review Again</Typography> */}
                <Typography className="DividerText">View Again</Typography>
                <Divider className="SASPDivider margin-bottom-16" />
                <Slider
                    defaultValue={2}
                    getAriaValueText={valuetext}
                    getAriaLabel={labelText}
                    aria-labelledby="SASP-Question-slider-custom"
                    aria-label = {labelText}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(valuetext) => labelText(valuetext)}
                    steps={1}
                    min={1}
                    max={5}
                    marks={marks}
                    onChangeCommitted={handleChange('onChangeCommitted')}
                />
            </div>
        );
    }   
}